module.exports = __webpack_public_path__ + "static/media/emo3.00bff3c0.svg";